import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { cardsDataQueryKey } from 'api/queries/cardsData.query';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { executionConfig as config } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { MyFocusHeader } from 'components/widgets/myFocusHeader/myFocusHeader';
import { MyNotificationsWidget } from 'components/widgets/myNotifications/myNotificationsWidget';
import { MyPrioritiesWrapper } from 'components/widgets/myPriorities/myPrioritiesWrapper';
import { MyProjectScoreCardWidget } from 'components/widgets/myProjectScoreCard/myProjectScoreCardWidget';
import { MyTrackedActivitiesWrapper } from 'components/widgets/myTrackedActivities/myTrackedActivitiesWrapper';

export const MyFocusPage = () => {
    useFullStoryPageView({ pageName: config.myFocusPage.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <ShareInsightButton title={config.myFocusPage.title} link={window.location.href} />
                            <VersionCompareSelectorWrapper isBaselineSelected={true} allowSingleVersion={true} />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={config.myFocusPage.title} />
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <MyFocusHeader />
                <div style={{ display: 'flex', gap: '48px' }}>
                    <div style={{ flex: 2 }}>
                        <MyPrioritiesWrapper />
                    </div>
                    <div style={{ flex: 1 }}>
                        <MyProjectScoreCardWidget />
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '48px' }}>
                    <div style={{ flex: 2 }}>
                        <MyTrackedActivitiesWrapper />
                    </div>
                    <div style={{ flex: 1 }}>
                        <MyNotificationsWidget />
                    </div>
                </div>
            </MainContent>
            <MainCardRoutingModal queryKeys={[cardsDataQueryKey, 'summaryTrackedActivitiesTableData']} />
        </PageContainer>
    );
};
